if (!customElements.get('sticky-collection-toolbar')) {
  customElements.define(
    'sticky-collection-toolbar',
    class StickyCollectionToolbar extends HTMLElement {
      connectedCallback() {
        this.toolbar = this.querySelector('.collection__toolbar');
        if (!this.toolbar) return;

        this.sentinel = document.createElement('span');
        this.sentinel.setAttribute('aria-hidden', 'true');
        this.sentinel.style.cssText = 'display:block;height:0;pointer-events:none;';
        this.before(this.sentinel);

        this.updateStickyState = this.updateStickyState.bind(this);
        this.requestStickyUpdate = this.requestStickyUpdate.bind(this);
        window.addEventListener('scroll', this.requestStickyUpdate, { passive: true });
        window.addEventListener('resize', this.requestStickyUpdate, { passive: true });
        this.updateStickyState();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.requestStickyUpdate);
        window.removeEventListener('resize', this.requestStickyUpdate);
        this.sentinel?.remove();
        cancelAnimationFrame(this.frameRequest);
      }

      requestStickyUpdate() {
        cancelAnimationFrame(this.frameRequest);
        this.frameRequest = requestAnimationFrame(this.updateStickyState);
      }

      updateStickyState() {
        const stickyTop = Number.parseFloat(getComputedStyle(this).top) || 0;
        const toolbarTop = this.getBoundingClientRect().top;
        const hasPassedSentinel = this.sentinel.getBoundingClientRect().top <= stickyTop;
        const isPinnedToTop = Math.abs(toolbarTop - stickyTop) < 2;

        this.toolbar.classList.toggle('is-stuck', hasPassedSentinel && isPinnedToTop);
      }
    }
  );
}
